import { render, staticRenderFns } from "./LegendData.vue?vue&type=template&id=48f44824&scoped=true&lang=pug"
import script from "./LegendData.vue?vue&type=script&lang=js"
export * from "./LegendData.vue?vue&type=script&lang=js"
import style0 from "./LegendData.vue?vue&type=style&index=0&id=48f44824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f44824",
  null
  
)

export default component.exports